<template>
  <v-row
    no-gutters
    class="past-list-wrap"
  >
    <v-col
      v-if="showLoading"
      cols="12"
      sm="12"
      md="12"
      class="loading-container"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="20"
        width="2"
      />
    </v-col>

    <v-col
      v-else
      cols="12"
      sm="12"
      md="12"
      class="past-list-col"
    >
      <div class="past-list">
        <div
          v-for="session in sessions"
          :key="session.sessionId"
          class="past-item"
          role="button"
          tabindex="0"
          @click="$emit('select-session', session)"
          @keydown.enter="$emit('select-session', session)"
          @keydown.space.prevent="$emit('select-session', session)"
        >
          <v-icon
            size="15"
            class="past-item-icon"
          >
            mdi-message-outline
          </v-icon>
          <div class="past-item-content">
            <span class="past-item-title">
              {{ session.title || 'Untitled chat' }}
            </span>

            <span class="past-item-date">
              {{ session.date }}
            </span>

            <span class="past-item-delete-col">
              <button
                type="button"
                class="past-item-delete-btn"
                aria-label="Delete chat"
                @click.stop="$emit('delete-session', session)"
              >
                <v-icon
                  size="18"
                  class="past-item-delete-icon"
                >
                  mdi-trash-can-outline
                </v-icon>
              </button>
            </span>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PastActivityList',

  props: {
    sessions: {
      type   : Array,
      default: () => []
    },

    loading: {
      type   : Boolean,
      default: false
    }
  },

  computed: {
    showLoading () {
      return this.loading
    }
  }
}
</script>

<style scoped>
.past-item-content {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.past-list-wrap {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  flex-wrap: nowrap;

  width: 100%;
  height: 100%;

  min-width: 0;
  min-height: 0;

  margin: 0;

  overflow: hidden;
}

.loading-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding-top: 18px;
}

.past-list-col {
  display: flex;
  flex: 1 1 0 !important;

  width: 100%;
  max-width: 100%;

  min-width: 0;
  min-height: 0;

  padding: 0;

  overflow: hidden;

  background: transparent;
}

.past-list {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;

  gap: 0;

  width: 100%;
  height: 100%;

  min-width: 0;
  min-height: 0;

  padding: 2px 2px 8px 0;

  overflow-x: hidden;
  overflow-y: auto;

  scrollbar-width: none;
  scrollbar-color: transparent transparent;
}

.past-list:hover,
.past-list:focus-within {
  scrollbar-width: thin;
  scrollbar-color: #cdd6e4 transparent;
}

.past-list::-webkit-scrollbar {
  width: 6px;
}

.past-list::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 999px;
}

.past-list:hover::-webkit-scrollbar-thumb,
.past-list:focus-within::-webkit-scrollbar-thumb {
  background: #cdd6e4;
}

.past-list::-webkit-scrollbar-track {
  background: transparent;
}

.past-item {
  position: relative;
  isolation: isolate;
  display: flex;
  align-items: center;
  width: 100%;
  height: 24px;
  padding: 18px 12px;
  border-radius: 8px;
  background: transparent;
  color: #041F30;
  cursor: pointer;
  text-align: left;
  transition: border-color .15s ease, color .15s ease;
}

.past-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background: #ffffff;
  opacity: 0;
  z-index: -1;
  transition: opacity .15s ease;
}

.past-item:has(.past-item-delete-btn:hover)::before {
  opacity: 0 !important;
}

.past-item-icon {
  padding-right: 8px;
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  color: #6c829a !important;
}

.past-item-title {
  flex: 1 1 auto;
  min-width: 0;
  color: #041F30;
  font-size: 13px;
  font-family: 'Inter';
  white-space: nowrap;
  font-weight: 400;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.past-item-date {
  margin-left: auto;
  flex: 0 0 auto;
  color: #63747D;
  font-family: 'Inter';
  font-size: 10px;
  font-weight: 400;
  line-height: 21px;
  white-space: nowrap;
  text-align: right;
}

.past-item-delete-col {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}

.past-item-delete-btn {
  display: none;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s ease;
}

.past-item:hover .past-item-delete-btn {
  display: flex;
}

.past-item-delete-btn:hover {
  background-color: #ffffff;
}

.past-item-delete-icon {
  color: #63747D !important;
  transition: color 0.15s ease;
}

.past-item-delete-btn:hover .past-item-delete-icon {
  color: #041f30 !important;
}

.past-item:focus {
  outline: none;
}

.past-item:hover,
.past-item:focus-visible {
  border-color: #d4deef;
  color: #0d2940;
  outline: none;
}

.past-item:hover::before,
.past-item:focus-visible::before {
  opacity: 1;
}

.past-item:hover .past-item-icon,
.past-item:focus-visible .past-item-icon {
  color: #4f6784 !important;
}

.empty-state {
  padding: 14px 6px;
  color: #778a9d;
  font-size: 13px;
}
</style>
